@if (!isAuditor('GPIA')) {
<mat-card>
  <mat-card-title class="title">PROLONGATION PROCESS HISTORY</mat-card-title>
  @if (prolongationHistory) {
  <div [innerHTML]="prolongationHistory | userReplace"></div>
  }
</mat-card>
}
<mat-card>
  <mat-card-header>
    <mat-card-title class="title">MODIFICATIONS</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <mat-list
      role="list"
      class="generalTableStyle">
      <div class="row">
        <div class="col-md-5 col-sm-12">
          <b> This document has been </b>
        </div>
        <div class="col-md-3 col-sm-12">
          <b> on </b>
        </div>
        <div class="col-md-4 col-sm-12">
          <b> with actual Recommendation Status </b>
        </div>
      </div>
      @if(modificationLogs){ @for (log of modificationLogs; track log; let i = $index) {
      <div class="row item">
        <div class="col-md-5 col-sm-12">
          {{ log.action }}
        </div>
        <div class="col-md-3 col-sm-12">
          {{ log.createdAt | date : 'dd.MM.yyyy' : 'UTC' }}
        </div>
        <div class="col-md-4 col-sm-12">
          {{ log.status }}
        </div>
      </div>
      } }
    </mat-list>
  </mat-card-content>
</mat-card>
